import React, { useEffect, useState } from 'react';
import { ThreeDot } from 'react-loading-indicators';
import { generateSlug } from '../utils/slug';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import AdDetailsAdTitle from '../Components/AdDetailsAdTitle/AdDetailsAdTitle';
import AdDetailsImageGallery from '../Components/AdDetailsImageGallery/AdDetailsImageGallery';
import AdDetailsInfo from '../Components/AdDetailsInfo/AdDetailsInfo';
import AdDetailsFeatures from '../Components/AdDetailsFeatures/AdDetailsFeatures';
import AdDetailsDescription from '../Components/AdDetailsDescription/AdDetailsDescription';
//import AdDetailsOwner from '../Components/AdDetailsOwner/AdDetailsOwner';
import AdDetailsQA from '../Components/AdDetailsQA/AdDetailsQA';
import SimilarAds from '../Components/AdDetailsSimilarAds/AdDetailsSimilarAds';
import AdDetailsOwnerContact from '../Components/AdDetailsOwnerContact/AdDetailsOwnerContact';
import AdDetailsContactSeller from '../Components/AdDetailsContactSeller/AdDetailsContactSeller';
import AdDetailsAdAction from '../Components/AdDetailsAdAction/AdDetailsAdAction';
import AdMap from '../Components/AdDetailsMap/AdDetailsMap';
import "./AdDetails.css";

const AdDetails = () => {

    const { slug, id } = useParams();
    const [item, setAd] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAdDetails = async () => {
            try {
                const apiUrl = `${process.env.REACT_APP_API_URL}/oglas/${slug}/${id}`;
                const response = await fetch(apiUrl, {
                    method: 'GET',
                    credentials: 'include', // Ensures cookies/auth tokens are sent
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch item details');
                }

                const data = await response.json();
                setAd(data);

                // Shrani v LocalStorage za "nazadnje ogledano"
                const ogledaniOglasi = JSON.parse(localStorage.getItem('nazadnjeOgledano')) || [];

                const filtered = ogledaniOglasi.filter(item => item.id !== data.id);

                const newUrl = `/oglas/${generateSlug(data.title)}/${data.id}`;

                filtered.unshift({
                    id: data.id,
                    url: newUrl,
                });

                const updated = filtered.slice(0, 5);

                localStorage.setItem('nazadnjeOgledano', JSON.stringify(updated));

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAdDetails();
    }, [id, slug]);

    if (loading) return <ThreeDot variant="bounce" color="#FF4367" size="medium" text="Nalaganje" textColor="#FF4367" />;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;
    if (!item) return <div className="item-details-error"><h1>Oglas ni najden</h1><p>Oglas, ki ga iščete, morda ne obstaja več.</p></div>;

    // Sestavimo polno pot do oglasa za deljenje
    const fullAdLink = `${window.location.origin}/oglas/${slug}/${id}`;

    // Extract image URLs from the item
    //const imageUrls = item.images.map(image => image.image_url);

    // Extract user data from the item
    //const user_id = item?.user?.id || "Unknown";
    //const username = item?.user?.username || "Unknown";
    //const user_phone_number = item?.user?.phone_number || "Not available";
    //const user_since = item?.user?.created_at;

    return (
        <div className="item_details_bg">
            <Container className="item_details">
                <div className="row">

                    {/* item section + owner info */}
                    <div className="col-lg-9 main_section">
                        <div className="item_info">
                            <AdDetailsAdTitle title={item.title} />
                            <div className="image_gallery">
                                <AdDetailsImageGallery images={item.images} />
                            </div>
                            <AdDetailsInfo price={item.price} created_at={item.created_at} view_count_24={item.view_count_24} view_count_total={item.view_count_total} />
                            <AdDetailsFeatures item_condition={item.item_condition} category_id={item.category_id} />
                            <AdDetailsDescription description={item.description} />
                        </div>
                        {/*<div className="owner_info">
                            <AdDetailsOwner username={username} user_since={user_since} />
                        </div>*/}
                        <div className="owner_info">
                            <AdDetailsQA adId={id} ownerId={item.seller.id} />
                        </div>
                    </div>

                    {/* Right section (owner contact + location) */}
                    <div className="col-lg-3 action_section">
                        <AdDetailsOwnerContact user_id={item.seller.id} username={item.seller.username} user_phone_number={item.seller.phone_number} email_confirmed={item.seller.email_confirmed} />
                        <AdDetailsContactSeller sellerEmail={item.seller.email} adTitle={item.title} adId={id} ownerName={item.seller.username} adLink={fullAdLink} />
                        <AdDetailsAdAction adId={id} adTitle={item.title} />
                        <AdMap
                            latitude={item.seller.location.latitude}
                            longitude={item.seller.location.longitude}
                            zoom={13}
                        />
                    </div>

                </div>
                <div className="row">
                    <div className="col-12">
                        <SimilarAds slug={slug} adId={id} limit={8} />
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default AdDetails;